import { graphql } from 'react-relay';

export const refundHistory = graphql`
  query refundHistoryQuery {
    bznavRefund {
      user {
        name
        refundDetail {
          id
          corpType
          applicationInfo {
            bank # 은행명
            accountNo # 계좌번호
          }
          refundAmount # 환급액
          paymentDate # 결제 완료일
          paymentAmount # 이용료
          businessInfo {
            hometaxBizName # 법인명
            hometaxBizNo # 사업자등록번호
            taxpayerName # 개인사업자 이름
          }
          refundResultDt # 환급 결정일
          applicationDt # 환급 신청일
        }
      }
    }
  }
`;
